import clsx from "clsx";

import { Badge } from "@transfr-inc/dashboard-components";

import "./beta.badge.scss";

export const BetaBadge = ({ className }) => {
  return <Badge className={clsx("beta-badge", className)} value="BETA" />;
};
